"use client"

import { Button, Typography } from "@mui/material"
import { getCarfleetSubmitApplication } from "api"
import FormikForm from "common/bit/form/FormikForm"
import PrivacyPolicyCaption from "common/PrivacyPolicyCaption"
import { useState } from "react"
import FormCheckBoxWithLable from "reusable/formsComp/checkbox/FormCheckBoxWithLable"
import FormInput from "reusable/formsComp/FormInput"
import FormSelect from "reusable/formsComp/FormSelect"
import FormSuccessState from "reusable/formsComp/FormSuccessState"
import ErrorInFormPopup from "reusable/popups/ErrorInFormPopup"
import styled from "styled-components"
import schemaCarFleet, { initialFormStatesCarFleet } from "./SchemaCarFleet"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  .MuiFormControlLabel-root {
    margin-right: 0px;
  }
`
const StyledFormDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 660px;
  }
`
const StyledButton = styled(Button)`
  margin: 20px 0px;
`

const StyledRowCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: auto;
  gap: 2px;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    column-gap: 16px;
  }
`
const StyledWrap = styled.div`
  width: 100%;
  max-width: 320px;
`
const StyledSelectWrap = styled.div`
  width: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: calc(50% - 8px);
    margin-left: auto;
  }
`
const StyledRequiredFields = styled(Typography).attrs({ variant: "body2" })`
  color: ${(p) => p.theme.colors.mazdaRed};
  margin-left: auto;
`

// form status enum
export enum FormStatus {
  Normal = "normal",
  Success = "success",
  Error = "error",
}

const CarFleetForm = () => {
  const [formStatus, setFormStatus] = useState<FormStatus>(FormStatus.Normal)

  return (
    <>
      <StyledWrapper>
        {formStatus === FormStatus.Success && <FormSuccessState />}

        {/* Render form if Normal OR Error (so user can fix mistakes) */}
        {(formStatus === FormStatus.Error ||
          formStatus === FormStatus.Normal) && (
          <FormikForm
            validationSchema={schemaCarFleet}
            initialValues={initialFormStatesCarFleet}
            onSubmit={async (values) => {
              try {
                const formResponse = await getCarfleetSubmitApplication(
                  values.firstName,
                  values.lastName,
                  values.phoneNumber,
                  values.email,
                  values.organization ?? "",
                  values.organizationTitle ?? "",
                  values.subject ?? "",
                  values.message ?? "",
                  values.approveMailingList
                )

                // Check specific API response structure
                if (formResponse?.data) {
                  setFormStatus(FormStatus.Success)
                } else {
                  setFormStatus(FormStatus.Error)
                }
              } catch (error) {
                console.error("Submission error:", error)
                setFormStatus(FormStatus.Error)
              }
            }}
            render={(formik) => (
              <StyledFormDiv>
                <StyledRequiredFields>* שדות חובה</StyledRequiredFields>

                <StyledSelectWrap>
                  <FormSelect
                    name="subject"
                    required
                    label="נושא הפנייה"
                    values={[
                      "פגישה עם נציג המחלקה",
                      "תיאום נסיעת הדגמה",
                      "עניין אחר",
                    ]}
                    map={(item: string) => ({ id: item, name: item })}
                  />
                </StyledSelectWrap>

                <StyledRowCol>
                  <FormInput
                    name="firstName"
                    label="שם פרטי"
                    required
                    autoComplete="given-name"
                  />
                  <FormInput
                    name="lastName"
                    label="שם משפחה"
                    required
                    autoComplete="family-name"
                  />
                </StyledRowCol>
                <StyledRowCol>
                  <FormInput
                    name="email"
                    label="כתובת מייל"
                    autoComplete="email"
                    required
                    type="email"
                  />
                  <FormInput
                    name="phoneNumber"
                    label="נייד"
                    autoComplete="tel-national"
                    required
                    type="tel"
                  />
                </StyledRowCol>
                <StyledRowCol>
                  <FormInput
                    name="organization"
                    label="שם החברה"
                    autoComplete="organization"
                  />
                  <FormInput
                    name="organizationTitle"
                    label="תפקיד בחברה"
                    autoComplete="organization-title"
                  />
                </StyledRowCol>
                <FormInput
                  name="message"
                  label="?איך נוכל לעזור"
                  multiline
                  minRows={4}
                />
                <StyledRowCol>
                  <FormCheckBoxWithLable
                    name="approveMailingList"
                    label="אני רוצה לקבל עדכונים במייל ו/או בסמס מקבוצת דלק מוטורס על מבצעים, השקות, אירועים ועוד, ולהיכלל במאגר המידע של הקבוצה"
                  />
                </StyledRowCol>
                <PrivacyPolicyCaption style={{ margin: "22px 0 0" }} />

                <StyledWrap>
                  <StyledButton
                    disabled={formik.isSubmitting}
                    fullWidth
                    variant="text"
                    type={"submit"}
                  >
                    שליחה
                  </StyledButton>
                </StyledWrap>
              </StyledFormDiv>
            )}
          />
        )}
      </StyledWrapper>

      <ErrorInFormPopup
        open={formStatus === FormStatus.Error}
        onClose={() => setFormStatus(FormStatus.Normal)}
      />
    </>
  )
}

export default CarFleetForm
